var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSearchGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5920_18697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3377 4.31739L11.1506 1.41395C10.8116 1.10512 10.3679 0.935059 9.90128 0.935059H3.83353C2.83114 0.935059 2.01562 1.72036 2.01562 2.68562V15.4806C2.01562 16.4459 2.83114 17.2312 3.83353 17.2312H13.0883C14.0907 17.2312 14.9062 16.4459 14.9062 15.4806V5.58906C14.9062 5.11008 14.699 4.64656 14.3377 4.31739ZM13.3746 4.75446H10.9069C10.8157 4.75446 10.7416 4.68307 10.7416 4.59532V2.35575L13.3746 4.75446ZM13.0883 16.2763H3.83353C3.3779 16.2763 3.00721 15.9194 3.00721 15.4806V2.68562C3.00721 2.24686 3.3779 1.88991 3.83353 1.88991H9.75V4.59532C9.75 5.20957 10.269 5.70931 10.9069 5.70931H13.9147V15.4806C13.9147 15.9194 13.544 16.2763 13.0883 16.2763Z",
    fill: "#8F7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9979 7.30078H4.72626C4.45245 7.30078 4.23047 7.51454 4.23047 7.77821C4.23047 8.04187 4.45245 8.25563 4.72626 8.25563H11.9979C12.2717 8.25563 12.4937 8.04187 12.4937 7.77821C12.4937 7.51454 12.2717 7.30078 11.9979 7.30078Z",
    fill: "#8F7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9979 9.84717H4.72626C4.45245 9.84717 4.23047 10.0609 4.23047 10.3246C4.23047 10.5883 4.45245 10.802 4.72626 10.802H11.9979C12.2717 10.802 12.4937 10.5883 12.4937 10.3246C12.4937 10.0609 12.2717 9.84717 11.9979 9.84717Z",
    fill: "#8F7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12987 12.3931H4.72626C4.45245 12.3931 4.23047 12.6068 4.23047 12.8705C4.23047 13.1342 4.45245 13.3479 4.72626 13.3479H7.12987C7.40368 13.3479 7.62566 13.1342 7.62566 12.8705C7.62566 12.6068 7.40368 12.3931 7.12987 12.3931Z",
    fill: "#8F7DFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5920_18697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 18.0583C15.4243 18.0583 16.9167 16.6213 16.9167 14.8485C16.9167 13.0758 15.4243 11.6387 13.5833 11.6387C11.7424 11.6387 10.25 13.0758 10.25 14.8485C10.25 16.6213 11.7424 18.0583 13.5833 18.0583Z",
    fill: "#1A1A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 18.0583C15.4243 18.0583 16.9167 16.6213 16.9167 14.8485C16.9167 13.0758 15.4243 11.6387 13.5833 11.6387C11.7424 11.6387 10.25 13.0758 10.25 14.8485C10.25 16.6213 11.7424 18.0583 13.5833 18.0583Z",
    stroke: "#8F7DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 18.8611L15.9375 17.1157",
    stroke: "#8F7DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5920_18697",
    x: 5.75,
    y: 7.13867,
    width: 15.666,
    height: 15.4199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5920_18697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5920_18697",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5920_18697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9231,
    height: 16.2961,
    fill: "white",
    transform: "translate(0 0.935059)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSearchGradient);
export default __webpack_public_path__ + "static/media/documentSearchGradient.30919d3710a9e59889c7a39ce389a0ea.svg";
export { ForwardRef as ReactComponent };